import React from 'react';
interface AuroraFloatingCardProps {
  children: React.ReactNode;
  className?: string;
}
const AuroraFloatingCard: React.FC<AuroraFloatingCardProps> = ({
  children,
  className = ''
}) => {
  return <div className={`transition-all duration-300 ease-in-out hover:-translate-y-1 ${className}`} data-id="element-1817">
      <div className="p-[2px] bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 rounded-2xl shadow-xl shadow-purple-900/30 hover:shadow-purple-800/40" data-id="element-1818">
        <div className="relative isolate overflow-hidden bg-[#0D1117] backdrop-blur-md rounded-[14px] p-4 sm:p-6 h-full flex flex-col" data-id="element-1819">
          {/* Refined Aurora Effect with subtle color stains */}
          <div className="absolute -top-40 -right-40 -z-10 h-[250px] w-[250px] rounded-full bg-gradient-radial from-purple-900/20 to-transparent blur-3xl pointer-events-none" aria-hidden="true" data-id="element-1820"></div>
          <div className="absolute -bottom-20 -left-20 -z-10 h-[200px] w-[200px] rounded-full bg-gradient-radial from-blue-900/15 to-transparent blur-3xl pointer-events-none" style={{
          animationDelay: '1s'
        }} aria-hidden="true" data-id="element-1821"></div>
          <div className="absolute top-1/3 right-1/4 -z-10 h-[100px] w-[100px] rounded-full bg-gradient-radial from-pink-900/10 to-transparent blur-3xl pointer-events-none" style={{
          animationDelay: '2s'
        }} aria-hidden="true" data-id="element-1822"></div>
          <div className="absolute bottom-1/3 right-1/3 -z-10 h-[150px] w-[150px] rounded-full bg-gradient-radial from-indigo-900/15 to-transparent blur-3xl pointer-events-none" style={{
          animationDelay: '1.5s'
        }} aria-hidden="true" data-id="element-1823"></div>
          {/* KART İÇERİĞİ */}
          <div className="relative z-0 w-full h-full flex-1 overflow-auto" data-id="element-1824">
            {children}
          </div>
        </div>
      </div>
    </div>;
};
export default AuroraFloatingCard;